<template>
    <div class="release">
        <header>
            <div class="header">
                <h2>我的订单</h2>
            </div>
            <div class="line"></div>
            <div class="input_box">
                <input type="text" v-model="queryParams.spuName" @change="query();" placeholder="请输入资产名称" />
                <van-icon name="search" color="#969696" size="20" />
            </div>
            <div class="query_params" style="margin-bottom: 0;">
                <span @click="() => orderTypePickerRef.openPicker()">{{ queryParams.type ?
                    queryParams.typeName : '订单类型' }} <van-icon name="arrow-down" /></span>
            <span @click="() => timeRangePickerRef.openPicker()">创建时间 <van-icon name="arrow-down" /></span>

            </div>
        </header>

        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="list">
                <li v-for="item in list" :key="item.id">
                    <div class="name">
                        <p>{{ item.spuName }}</p>
                        <span @click="getAddress(item)">区块链地址</span>
                    </div>
                    <div class="line"></div>
                    <div class="content">
                        <div class="l">
                            <p>订单编号 <span>{{ item.no }}</span></p>
                            <p>订单类型 <span>{{ item.typeName }}</span></p>
                            <p>订单状态 <span>{{ item.statusName }}</span></p>
                        </div>
                        <div class="r">
                            <p>交易金额</p>
                            <p style="font-size: 20rem; color: #FF5733;"><b>￥{{ (item.payPrice / 100).toFixed(2) }}</b></p>
                            <p style="font-size: 12rem; color: #828282;">{{ item.createTime ? timeStampFormat(item.createTime) : '-' }}</p>
                        </div>
                    </div>

                </li>
            </ul>
        </van-list>
    </div>

    <order-type-picker ref="orderTypePickerRef"
        @confirm="d => { queryParams.type = d[0].id; queryParams.typeName = d[0].name; query() }" />
    <time-range-picker ref="timeRangePickerRef"
        @confirm="d => { queryParams.createTime = d.startDate.getTime() + ',' + d.endDate.getTime(); query() }" />


</template>

<script setup>
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { timeStampFormat } from '@/utils/util'
import orderTypePicker from '../../components/orderTypePicker.vue'
import timeRangePicker from '../../components/timeRangePicker.vue'

import { showNotify } from 'vant'

const orderTypePickerRef = ref(null)
const timeRangePickerRef = ref(null)

const router = useRouter()
const store = useStore()
const queryParams = reactive({
    type: null, //订单类型
    spuName: null, //资产名称
    status: null, //订单状态
    statusName: null, //订单状态名称
    createTime: null,
})
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
    total: 0
})

const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    http.get('/app-api/trade/order/shop-item-page', {
        params: Object.assign({}, queryParams, pagination)
    }).then(res => {
        loading.value = false
        finished.value = res.list.length < pagination.pageSize
        pagination.total = res.total
        list.value = [...list.value, ...res.list]
    })
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}

const getAddress = (item) => {
    http.get('app-api/member/certifInfo/selectOrdertxID', {
        params: {
            orderId: item.no
        }
    }).then(res => {
        showNotify({ type: 'warning', message: res });
        
    }).catch(err => {
        showNotify({ type: 'warning', message: err });
    })
}
onMounted(() => {
    fetchList()
})

</script>

<style lang="scss" scoped>
@use '../common.scss';

.release {
    background-color: #F6F6F6;
    min-height: 100vh;

    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }

    .list {
        padding-bottom: 50rem;

        li {
            background-color: #fff;
            width: 400rem;
            margin: 10rem auto;
            padding: 15rem;
            border-radius: 4rem;

            .name {
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-size: 14rem;

                span {
                    color: #0071BB;
                }
            }

            .line {
                width: 100%;
                height: 1rem;
                background-color: #F6F6F6;
                margin: 10rem 0;
            }

            .content {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .l{
                    width: 60%;
                    p{
                        height: 30rem;
                        line-height: 30rem;
                        color: #717171;
                        font-size: 14rem;
                        span{
                            color: #383838;
                        }
                    }
                }
                .r{
                    width: 40%; display: flex; flex-direction: column; align-items: flex-end;
                    p{
                        height: 30rem;
                        line-height: 30rem;
                        color: #717171;
                        font-size: 14rem;
                    }
                }
            }

            .time {
                font-size: 12rem;
                color: #717171;
                margin-top: 10rem;
                text-align: right;
            }
        }
    }
}
</style>